const smartlinkSettingKeys = {
    all: () => [{ entity: 'smartlinkSetting' }],
    allDetails: () => [{ ...smartlinkSettingKeys.all()[0], scope: 'detail' }],
    detailByShowId: (rawShowId) => [
        { ...smartlinkSettingKeys.allDetails()[0], showId: Number(rawShowId) },
    ],
};

export default smartlinkSettingKeys;
